import React from 'react'
import PropTypes from 'prop-types'

import heroIcon from '../images/hero-icon.svg'
import animatedHand from '../images/animated-hand.gif'
import textLogo from '../images/1D1L-text-logo-with-heart.svg'

export const HeaderHome = ({ siteTitle }) => (
  <header className='header' role='banner'>
    <div className='icon-hero padding-small bg-green'>
      <div className='icon-hero__content'>
        <div className='container'>
          <h1 className='visuallyhidden'>{siteTitle}</h1>
          <div>
            <picture>
              <source srcSet={animatedHand} media='(min-width: 720px)' />
              <img className='header__hand-icon' src={heroIcon} alt='' />
            </picture>

            <img
              className='header__text-logo'
              src={textLogo}
              alt='1dollar1love text logo'
            />

            <blockquote className='header__quote'>
              <p>
                &ldquo;Now that we found love what are we gonna do with
                it?&nbsp;
                <span>Spread it all over.</span>&rdquo;
              </p>
              <div className='header__quote-footer'>
                <p>
                  Kenneth Gamble + Leon Huff
                  <br />
                  performed by Third World,
                  <br />
                  remixed by Monsieur ZonZon
                </p>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </header>
)

HeaderHome.propTypes = {
  siteTitle: PropTypes.string,
}

HeaderHome.defaultProps = {
  siteTitle: ``,
}
